import { render, staticRenderFns } from "./TeamMemberList.vue?vue&type=template&id=761b9474&"
import script from "./TeamMemberList.vue?vue&type=script&lang=js&"
export * from "./TeamMemberList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports